import Icon from '../components/Icon';

const CheckOutline = Icon(
  'check-outline',
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.643 8.043a.75.75 0 0 0-1.036-1.086l-4.985 4.756-2.229-2.13a.75.75 0 1 0-1.036 1.084l2.747 2.625a.75.75 0 0 0 1.036 0l5.503-5.25Z"
    />
  </>
);

export default CheckOutline;
